const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const AUTOMATION_TEST_EMAIL_PATH = '/api/platform/automations/email-action/test';

export function getAutomationApiBase() {
  return (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
}

export function parseTestEmailInput(input = '') {
  return input
    .split(',')
    .map((email) => email.trim())
    .filter(Boolean);
}

export function validateTestEmailInput(input = '') {
  const emails = parseTestEmailInput(input);
  if (!emails.length) {
    return 'Please enter at least one email address';
  }
  const invalidEmails = emails.filter((email) => !EMAIL_REGEX.test(email));
  if (invalidEmails.length > 0) {
    return `Invalid email(s): ${invalidEmails.join(', ')}`;
  }
  return '';
}

export function formatTestEmailSuccessMessage(data, recipients = []) {
  const recipient =
    data?.recipient ||
    recipients[0] ||
    (Array.isArray(data?.results) && data.results.find((r) => r?.email)?.email) ||
    '';

  if (recipient) {
    return `Test email sent successfully to ${recipient}.`;
  }
  return data?.message || 'Test email sent successfully.';
}

export function formatTestEmailErrorMessage(data, fallback = 'Test email could not be sent.') {
  if (data?.provider_error) {
    return data.provider_error;
  }
  if (data?.message && data.success === false) {
    return data.message;
  }
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors.join('; ');
  }
  if (typeof data?.detail === 'string') {
    return data.detail;
  }
  return fallback;
}

export function isAutomationTestEmailSuccess(response, data) {
  return Boolean(response?.ok && data?.success === true);
}

export async function sendAutomationTestEmail({
  apiBase = getAutomationApiBase(),
  token,
  recipients,
  subject,
  bodyHtml,
  bodyText,
  fromName,
  fromEmail,
  workflowId,
  actionId,
}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const payload = {
    test_emails: recipients,
    subject: subject || '[TEST] Email Preview',
    body_html: bodyHtml,
    body_text: bodyText,
    from_name: fromName,
    from_email: fromEmail,
    workflow_id: workflowId,
    action_id: actionId,
  };

  const response = await fetch(`${apiBase}${AUTOMATION_TEST_EMAIL_PATH}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  let data = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  return { response, data };
}
